import React, { useEffect, useRef } from "react";
import { Helmet } from "react-helmet";

import {
  Faq,
  Hero,
  Integration,
  Signup,
  Steps,
  UserFeedback,
} from "../components/content/";
import NavBarHome from "../components/NavBarHome";

const Home = ({ location }) => {
  let refs = {
    about: useRef(),
    testimonials: useRef(),
    faq: useRef(),
    "example-posts": useRef(),
  };
  useEffect(() => {
    const refNode = location.hash.replace("#", "");
    if (location.hash && refs[refNode]?.current) {
      refs[refNode].current.scrollIntoView({ block: "start" });
    }
  }, [location.hash, refs]);

  return (
    <div
      style={{
        marginTop: 112,
      }}
    >
      <Helmet>
        <title>Copysmith - Your AI Copywriter</title>
      </Helmet>
      <NavBarHome />
      <div ref={refs.about}>
        <Hero />
      </div>
      <Steps />
      {/* <BrandList /> */}
      <Integration />
      <div ref={refs.testimonials}>
        <UserFeedback />
      </div>
      {/*<div ref = {refs['example-posts']}><Examples /><
          /div> */}
      <div ref={refs.faq}>
        <Faq />
      </div>
      <Signup />
    </div>
  );
};

export default Home;
